import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const notifications_endpoints = APIS_ENDPOINTS.notifications

export const request_getAll = async ({
  CurrentPage,
  PageSize,
}: {
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    notifications_endpoints.getallnotification + `?CurrentPage=${CurrentPage}&PageSize=${PageSize}`
  )
}
